<template>
    <div class="footer-bg">
        <div class="f-logo" @click="getActiveHref('/')">
            <img src="@/assets/logo.png"/>
            <div class="bottom-text">© Copyright 2024 - All Rights Reserved</div>
        </div>
        <div class="f-text">
            <div class="text-top">
                <div class="item" @click="getActiveHref('/')">HOME</div>
                <div class="item" @click="getActiveHref('/technology')">TECHNOLOGY</div>
                <div class="item" @click="getActiveHref('/team')">TEAM</div>
                <div class="item" @click="getActiveHref('/contact')">CONTACT US</div>
            </div>
            <div class="email">support@buildeffiai.com</div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            getActiveHref(path) {
                this.$router.push(path);
            }
        }
    }
</script>

<style scoped lang="scss">
.footer-bg {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 235px;
    padding: 0 50px;
    background-color: #0a0c35;

    .bottom-text {
        color: #FFFFFF;
        font-size: 14px;
        line-height: 16px;
    }
}

.f-logo {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    position: relative;

    > img {
        height: 62px;
        cursor: pointer;
        object-fit: contain;
        margin-bottom: 20px;
    }
}

.f-text {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .text-top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        width: 100%;
        height: 62px;
        margin-bottom: 20px;

        > .item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: auto;
            font-size: 14px;
            font-weight: 400;
            line-height: 40px;
            color: #FFFFFF;
            margin-left: 30px;

            &:hover {
                cursor: pointer;
                opacity: .8;
            }
        }
    }

    .email {
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        width: 100%;
        font-size: 14px;
        line-height: 16px;
        color: #FFFFFF;
    }
}
</style>